import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-foreground-200/20'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-3 group"
          >
            <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-900 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <i className="ri-eye-line text-accent-500 text-xl md:text-2xl"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-lg md:text-xl font-heading font-bold text-foreground-900 tracking-wide">
                {siteConfig.name}
              </span>
              <span className="text-[10px] md:text-xs text-foreground-500 tracking-wider">
                {siteConfig.tagline}
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-sm font-label font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-accent-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
                {location.pathname === link.href && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-accent-500 rounded-full" />
                )}
              </Link>
            ))}
            <Link
              to="/about#contact"
              className="px-5 py-2 rounded-full bg-primary-900 text-background-50 text-sm font-label font-medium hover:bg-primary-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              爆料投稿
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-foreground-200/20">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`py-2 text-sm font-label font-medium transition-colors duration-200 ${
                  location.pathname === link.href
                    ? 'text-accent-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about#contact"
              className="mt-2 px-5 py-3 rounded-full bg-primary-900 text-background-50 text-sm font-label font-medium text-center hover:bg-primary-800 transition-all duration-200 cursor-pointer"
            >
              爆料投稿
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}